import { ChangeEvent, useCallback, useState } from 'react';
import { TabbedComponentContainer, Box } from '@streem/ui-react';
import PageHeader from '../../components/page_header/page_header';
import { MyCallLogPage } from './my_call_log_page';

import { observer } from 'mobx-react';
import { Switch, Route } from 'react-router-dom';
import { TeamCallLogPage } from './team_call_log_page';
import { RolesAuth } from '../../components/authorization/roles_auth';
import { PageColumn } from '../page_column';
import { useCallLogSavedFilter } from '../../hooks/use_call_log_saved_filter';
import { useCallLogsPageTabLinks } from '../../hooks/use_call_logs_page_tab_links';

export const CallLogsPage = observer(() => {
    const savedSearchValue = useCallLogSavedFilter();
    const [searchString, setSearchString] = useState(savedSearchValue);
    const { tabLinks } = useCallLogsPageTabLinks();

    const filterSearch = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        e.persist();
        setSearchString(e.target.value);
    }, []);

    const clearSearch = useCallback(() => {
        setSearchString('');
    }, []);

    return (
        <PageColumn>
            <Box pb={4} px={4}>
                <PageHeader
                    title="Streem Calls"
                    onSearch={filterSearch}
                    searchPlaceholder={'Search Streem Calls'}
                    searchValue={searchString}
                />
            </Box>
            <TabbedComponentContainer tabLinks={tabLinks} overflowY="hidden">
                <Switch>
                    <Route
                        key={'streems'}
                        path={['/companies/:company/teamcalls', '/teamcalls']}
                        exact={true}
                    >
                        <TeamCallLogPage searchString={searchString} clearSearch={clearSearch} />
                    </Route>
                    <RolesAuth except="SUPER_ADMIN">
                        <Route path="/mycalls" exact={true} key="mycalls">
                            <MyCallLogPage searchString={searchString} />
                        </Route>
                    </RolesAuth>
                </Switch>
            </TabbedComponentContainer>
        </PageColumn>
    );
});
